import { compose } from 'recompose';
import { source } from 'react-aim';

import Item from './Item';

const enhance = compose(
    source({
        mouseEnter: ({ toggleSubCategories, categoryIndex }) => {
            toggleSubCategories(categoryIndex);
        },
    }),
);

export default enhance(Item);
